import React, { ReactNode } from "react";
import { MapPin } from "lucide-react";
import { useAuth } from '../contexts/AuthContext';

interface AppHeaderProps {
  isDarkMode: boolean;
  children?: ReactNode;
}

const AppHeader: React.FC<AppHeaderProps> = ({ isDarkMode, children }) => {
  const { loading } = useAuth();
  return (
    <header className="absolute top-4 left-[15%] right-[15%] z-[200] hidden md:block">
      <div
        className={`${isDarkMode ? "bg-gray-800/95 border-gray-700/20" : "bg-white/95 border-white/20"} backdrop-blur-sm shadow-lg rounded-2xl px-4 border flex items-center`}
        style={{ height: 'var(--header-height)' }}
      >
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center space-x-2">
            <MapPin className="h-6 w-6 text-blue-600" />
            <h1 className={`text-xl font-bold ${isDarkMode ? "text-white" : "text-gray-900"}`}>LoppeHub</h1>
          </div>
          {/* Actions will be injected as children */}
          <div className="flex items-center space-x-3">
            {loading ? (
              <div className="w-8 h-8 bg-gray-300 dark:bg-gray-600 rounded-full animate-pulse"></div>
            ) : (
              children
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
